var map = {
	"./custom/app/shared/auth-nav-menu/user-menu/user-menu.component": [
		39168,
		[
			"default-node_modules_ng2-file-upload_fesm2022_ng2-file-upload_mjs",
			"default-src_app_shared_upload_uploader_uploader_component_ts",
			"default-src_app_notifications_suggestions_notification_suggestions-notification_component_ts",
			"default-src_app_shared_entity-dropdown_entity-dropdown_component_ts",
			"default-src_app_my-dspace-page_my-dspace-page_component_ts",
			"default-src_app_shared_auth-nav-menu_user-menu_user-menu_component_ts",
			"src_themes_custom_app_shared_auth-nav-menu_user-menu_user-menu_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13361;
module.exports = webpackAsyncContext;